import styled from 'styled-components';
import {
  tablet_portrait_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const CuratedCollectionsStyles = styled.div`
  .area-header {
    height: 225px;

    a {
      text-decoration: none;
    }
  }

  .constrained-width {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .find-a-home-link {
    align-items: center;
    display: flex;
    flex-direction: row;
    text-decoration: underline;

    svg {
      margin-top: 14px;

      * {
        fill: ${Colors.primary.white.standard};
      }
    }
  }

  .home-card-detailed {
    margin-bottom: 20px;
    width: 100%;
  }

  .collection-header {
    align-items: center;
    background-color: ${Colors.primary.white.standard};
    display: flex;
    flex-direction: column;
    min-height: 300px;
    margin: auto;
    margin-bottom: 25px;
    margin-top: -170px;
    padding: 10px;
    padding-top: 40px;
    text-align: center;
    width: 100%;

    h1 {
      margin-top: 15px;
      margin-bottom: 15px;
    }

    img {
      margin-bottom: 15px;
      max-width: 100px;
    }
  }

  .cta {
    margin-bottom: 20px;
  }
  .cta {
    /* Adjusting these h4 headers to match h2 header font size used in Figma */
    p.h4.cta-heading {
      /* 26px is h2 font size for mobile */
      font-size: 26px;
    }
  }

  .cta-buttons a {
    margin-right: 20px;
  }

  .curated-cta {
    width: 100%;
  }

  .load-more {
    margin-bottom: 20px;
  }

  .home-card-link {
    width: 100%;
  }

  .collection-location {
    margin-bottom: 25px;
  }

  .collection-location-indicator,
  .zip-current {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    svg {
      position: relative;
      top: 2px;
    }

    label {
      color: ${Colors.primary.black.standard};
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }

  .location-modal {
    position: fixed;
  }

  .modal-container {
    border-radius: 4px;
  }

  .collection-location {
    .modal-content {
      overflow: visible;
    }
    .location-form {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      max-width: 400px;
      padding: 20px 10px;
      width: 95vw;
      white-space: nowrap;

      .distance.dropdown-list {
        margin-right: 5px;
        width: 100px;
      }
      .suggestion-box {
        margin-left: 5px;
        min-width: 100px;

        .dropdown-menu {
          left: auto;
          min-width: 200px;
          right: 0px;
        }
      }
      .dropdown-filter {
        height: 150vh;
        left: -50vw;
        top: -50vh;
        width: 150vw;
      }
      .dropdown-menu {
        top: 50%;
      }
      .error-message {
        min-width: 160px;
        position: absolute;
        right: 0;
        width: 100%;
      }
    }

    .location-controls {
      border-top: solid 1px ${Colors.primary.black.tint};
      display: flex;
      justify-content: flex-end;
      padding: 10px;
    }
  }

  a.zip-current:link,
  a.zip-current:visited,
  a.zip-current:hover,
  a.zip-current:active {
    text-decoration: none;
  }

  .zip-indicator,
  .distance-indicator {
    color: ${Colors.primary.claytonBlue.standard};
  }

  .collection-location-updating {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 30px;

    .label.large {
      margin-right: 5px;
    }

    & > div {
      margin-top: 15px;
    }
  }

  .curated-collection-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
    text-align: center;

    svg {
      margin-top: -75px;
      max-width: 100%;
    }
  }

  .disclaimer {
    background-color: ${Colors.accent.grey7.standard};
    padding: 50px 0;
    .markdown p {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.57;
      letter-spacing: normal;
    }
  }

  .illustration-container {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 10px;
    height: 100vh;
    max-height: 177px;
    position: relative;
    width: 100vw;
  }

  @media only screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .illustration-container {
      max-height: 334px;
    }
  }

  /* Hide the CTA image for mobile views (see Figma) */
  @media only screen and (max-width: ${desktop_breakpoint}px) {
    .cta {
      background-image: none;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .collection-header {
      h1,
      p {
        max-width: 800px;
        width: 80%;
      }
    }

    .load-more {
      width: auto;
    }

    .cta {
      /* Adjusting these h4 headers to match h2 header font size used in Figma */
      /* Also adjusting width to match Figma design. */
      background-position-y: bottom;
      max-width: none;
      width: 100%;

      p.h4.cta-heading {
        max-width: 55%;
      }
    }

    .illustration-container {
      margin-top: 50px;
      margin-bottom: 20px;
      max-height: 420px;
    }
  }
  .curated-collection-empty {
    svg {
      margin-top: 25px;
    }
  }
`;

export default CuratedCollectionsStyles;
